import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VideogameAssetIcon(props: IconProps) {
    return <Icon {...props} iconKey={"videogame_asset"}/>
}
